<template>
  <div class="container mx-auto">
    <div class="">
      <div class="space-y-8 mt-12">
        <section class="content">
          <h1 class="text-5xl font-extrabold">
            <span
              class="
                bg-clip-text
                text-transparent
                bg-gradient-to-r
                from-green-400
                to-blue-500
              "
            >
              Документы
            </span>
          </h1>
        </section>

        <section class="content">
          <h2 class="text-3xl">Лицензия ФСБ</h2>

          <div class="tomu-figures tomu-gallery tomu-gallery-fsb">
            <div class="tomu-figure">
              <div class="tomu-image">
                <img
                  src="@/assets/images/documents/license-FSB-1_Page1-0.25x.jpg"
                  alt="Том Универсал Лицензия ФСБ"
                />
              </div>
              <div class="tomu-image-subtitle"></div>
            </div>
            <div class="tomu-figure">
              <div class="tomu-image">
                <img
                  src="@/assets/images/documents/license-FSB-1_Page2-0.25x.jpg"
                  alt="Том Универсал Лицензия ФСБ"
                />
              </div>
              <div class="tomu-image-subtitle"></div>
            </div>
          </div>
        </section>

        <section class="content space-y-4">
          <h2 class="text-3xl">Реквизиты</h2>

          <div class="flex">
            <div class="">
              <div class="tomu-heading-3">
                <a class="tomu-anchor" id="inn"></a>
                ИНН
              </div>

              <div class="tomu-figures tomu-gallery tomu-gallery-inn">
                <div class="tomu-figure">
                  <div class="tomu-image">
                    <img
                      src="@/assets/images/documents/INN-TU-0.25x.jpg"
                      alt="Том Универсал Свидетельство ИНН"
                    />
                  </div>
                  <div class="tomu-image-subtitle"></div>
                </div>
              </div>
            </div>

            <div class="ml-12">
              <div class="tomu-heading-3">
                <a class="tomu-anchor" id="ogrn"></a>
                ОГРН
              </div>

              <div class="tomu-figures tomu-gallery tomu-gallery-ogrn">
                <div class="tomu-figure">
                  <div class="tomu-image">
                    <img
                      src="@/assets/images/documents/ogrn-0.25x.jpg"
                      alt="Том Универсал Свидетельство ОГРН"
                    />
                  </div>
                  <div class="tomu-image-subtitle"></div>
                </div>
                <div class="tomu-figure">
                  <div class="tomu-image">
                    <img
                      src="@/assets/images/documents/ogrn-izmeneniya-0.25x.jpg"
                      alt="Том Универсал Свидетельство ОГРН с изм."
                    />
                  </div>
                  <div class="tomu-image-subtitle"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <documents-photoswipe />
</template>

<script>
import PhotoSwipe from "photoswipe/dist/photoswipe.min";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default.min";

/*eslint-disable */

import DocumentsPhotoswipe from "@/components/documents/DocumentsPhotoswipe";

export default {
  name: "Documents",
  components: { DocumentsPhotoswipe },
  mounted() {
    // ФСБ
    const itemsFsb = [
      {
        msrc: require("@/assets/images/documents/license-FSB-1_Page1-0.25x.jpg"),
        src: require("@/assets/images/documents/license-FSB-1_Page1-1x.jpg"),
        w: 816,
        h: 1123,
        title: "Том Универсал - Лицензия ФСБ - Страница 1",
      },
      {
        msrc: require("@/assets/images/documents/license-FSB-1_Page2-0.25x.jpg"),
        src: require("@/assets/images/documents/license-FSB-1_Page2-1x.jpg"),
        w: 816,
        h: 1123,
        title: "Том Универсал - Лицензия ФСБ - Страница 2",
      },
    ];

    // ИНН
    const itemsINN = [
      {
        msrc: require("@/assets/images/documents/INN-TU-0.25x.jpg"),
        src: require("@/assets/images/documents/INN-TU-1x.jpg"),
        w: 2550,
        h: 3507,
        title: "Том Универсал - Свидетельство ИНН",
      },
    ];

    // ОГРН
    const itemsOGRN = [
      {
        msrc: require("@/assets/images/documents/ogrn-0.25x.jpg"),
        src: require("@/assets/images/documents/ogrn-1x.jpg"),
        w: 1700,
        h: 2338,
        title: "Том Универсал - Свидетельство ОГРН",
      },
      {
        msrc: require("@/assets/images/documents/ogrn-izmeneniya-0.25x.jpg"),
        src: require("@/assets/images/documents/ogrn-izmeneniya-1x.jpg"),
        w: 2550,
        h: 3507,
        title: "Том Универсал - Свидетельство ОГРН с изм.",
      },
    ];

    function openPhotoSwipeGallery(items) {
      const pswpElement = document.querySelectorAll(".pswp")[0];

      const options = {
        index: 0,
        bgOpacity: 0.7,
      };

      const gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );
      gallery.init();
    }

    const tomuGalleries = document.querySelectorAll(".tomu-gallery");

    tomuGalleries.forEach((galleryElement, key, parent) => {
      galleryElement
        .querySelectorAll(".tomu-figure")
        .forEach((figureElement, key, parent) => {
          if (galleryElement.classList.contains("tomu-gallery-fsb"))
            figureElement.addEventListener("click", (event) =>
              openPhotoSwipeGallery(itemsFsb)
            );
          else if (galleryElement.classList.contains("tomu-gallery-inn"))
            figureElement.addEventListener("click", (event) =>
              openPhotoSwipeGallery(itemsINN)
            );
          else if (galleryElement.classList.contains("tomu-gallery-ogrn"))
            figureElement.addEventListener("click", (event) =>
              openPhotoSwipeGallery(itemsOGRN)
            );
        });
    });
  },
};

/*eslint-enable */
</script>

<style scoped>
@import "~photoswipe/dist/photoswipe.css";
@import "~photoswipe/dist/default-skin/default-skin.css";

.tomu-heading-1 {
  font-size: 1.75rem;
}

.tomu-heading-2 {
  font-size: 1.5rem;
}

.tomu-heading-3 {
  font-size: 1.3rem;
}

.tomu-heading-4 {
  font-size: 1.15rem;
}

.tomu-heading-5 {
  font-size: 1rem;
}

.tomu-gallery {
  box-sizing: border-box;

  .tomu-figure {
    cursor: zoom-in;

    img:hover {
      outline: 2px solid #00b89c;
    }
  }
}

.tomu-figure {
  padding: 0 5px;
  display: inline-block;

  .tomu-image {
    min-width: 100px;
    min-height: 133.3333px;
    max-width: 120px;
  }
  .tomu-image-subtitle {
    padding: 5px 0;
    text-align: center;
  }
}

.tomu-figures {
  padding: 10px;
}
</style>
